<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'editor',
  data() {
    return {
      localSelections: [] as any[],
    };
  },
  methods: {
    changeSelection(selection: any) {
      if (selection.ResultStatus === 'Partial') {
        selection.AdditionalResultData = {
          Place: 0,
          CountInPlace: 0,
          PercentageWin: 0,
          PercentagePush: 50,
        };
      } else if (selection.ResultStatus === 'Placed') {
        selection.AdditionalResultData = {
          Place: 0,
          CountInPlace: 1,
          PercentageWin: 0,
          PercentagePush: 0,
        };
      } else {
        selection.AdditionalResultData = null;
      }

      this.$emit('update', selection);
    },
  },
  props: ['market'],
  watch: {
    'market.Selections': {
      immediate: true,
      handler(newSelections) {
        this.localSelections = newSelections.map((sel: object) => ({ ...sel }));
      },
    },
  },
});
</script>

<template>
  <div class="overflow-hidden">
    <template v-for="(selection, i) of localSelections" :key="i">
      <div v-if="!market.Selections[i].ResultStatus" class="p-2 bg-gray-700 grid grid-cols-2 border-b-8 border-b-gray-800">
        <div>
          <span class="font-mono text-gray-500 text-sm">{{ selection.Id }}</span>
          {{ selection.Name }}
        </div>
        <div>
          <select
            v-model="selection.ResultStatus"
            @change="changeSelection(selection)"
            class="mx-2 p-2"
          >
            <option :value="null">&lt;пусто&gt;</option>
            <option value="Winner">Победа</option>
            <option value="Loser">Проигрыш</option>
            <option value="Pushed">Возврат</option>
            <option value="Placed">Призовое место</option>
            <option value="Partial">Частичный результат</option>
          </select>
          <template v-if="selection.AdditionalResultData && selection.ResultStatus === 'Partial'">
            <span class="p-2 mx-2">Выигрыш</span>
            <select v-model="selection.AdditionalResultData.PercentageWin" class="p-2">
              <option :value="0">0</option>
              <option :value="50">50%</option>
            </select>
            <span class="p-2 mx-2">Возврат</span>
            <select v-model="selection.AdditionalResultData.PercentagePush" class="p-2">
              <option :value="0">0</option>
              <option :value="50">50%</option>
            </select>
          </template>
          <template v-if="selection.AdditionalResultData && selection.ResultStatus === 'Placed'">
            <span class="p-2 mx-2">Место</span>
            <input
              v-model="selection.AdditionalResultData.Place"
              type="number"
              min="0"
              max="10"
              class="p-1.5 w-14"
            />
            <span class="p-2 mx-2">Участников</span>
            <input
              v-model="selection.AdditionalResultData.CountInPlace"
              min="0"
              type="number"
              class="p-1.5 w-14"
            />
          </template>
        </div>
      </div>
    </template>
  </div>
</template>
